import React from 'react';
import { View } from 'react-native-web';
import Square from '../Shapes/Square';
import Circle from '../Shapes/Circle';
import {
  bars_enam, Icon_str, round_enam, square_enam,
} from '../../../utils/DictionaryManagementUtils';
import SquareInBar from '../Shapes/SquareInBar';

//= ========================================================================

const LayoutBar = ({
  globJSON, onConfigChanged, iconShape, isSelected,
}) => {
  const onIconShapeChanged = (value) => {
    globJSON.configurations.services.menu.icon_shape_bars_enam = value;
    onConfigChanged();
  };
  const isBar = iconShape === bars_enam;
  const isSquare = iconShape === square_enam;
  const isRound = iconShape === round_enam;
  const myStyle = { flexDirection: 'row', justifyContent: 'space-between' };

  return (
    <View>
      {isBar
      && (
      <View style={myStyle}>
        <SquareInBar isSelected={isSelected} onPress={() => { onIconShapeChanged(iconShape); }} />
      </View>
      )}
      {isSquare
      && (
        <View style={myStyle}>
          <Square isSelected={isSelected} text={Icon_str} onPress={() => { onIconShapeChanged(iconShape); }} />
          <Square isSelected={isSelected} text={Icon_str} onPress={() => { onIconShapeChanged(iconShape); }} />
        </View>
      )}
      {isRound
      && (
        <View style={myStyle}>
          <Circle isSelected={isSelected} text={Icon_str} onPress={() => { onIconShapeChanged(iconShape); }} />
          <Circle isSelected={isSelected} text={Icon_str} onPress={() => { onIconShapeChanged(iconShape); }} />
        </View>
      )}
    </View>
  );
};
export default LayoutBar;
